var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "invoice-add-wrapper" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center mb-1" },
        [
          _vm.loading
            ? _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning", block: "" },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.loading
        ? _c(
            "b-form",
            { on: { change: _vm.submitFormText } },
            [
              _c(
                "b-row",
                { staticClass: "invoice-add" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", xl: "12", md: "12" } },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "invoice-preview-card",
                          attrs: { "no-body": "" },
                        },
                        [
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding pb-0" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "invoice-number-date mt-md-0 mt-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center mb-1",
                                        },
                                        [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v("Start Date: "),
                                          ]),
                                          _c("flat-pickr", {
                                            staticClass:
                                              "form-control invoice-edit-input",
                                            attrs: { required: "" },
                                            model: {
                                              value: _vm.template.startDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.template,
                                                  "startDate",
                                                  $$v
                                                )
                                              },
                                              expression: "template.startDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v(" Due Date: "),
                                          ]),
                                          _c("flat-pickr", {
                                            staticClass:
                                              "form-control invoice-edit-input",
                                            attrs: { required: "" },
                                            model: {
                                              value: _vm.template.dueDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.template,
                                                  "dueDate",
                                                  $$v
                                                )
                                              },
                                              expression: "template.dueDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding pb-0" },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "mt-md-0 mt-3 d-flex align-items-center",
                                      attrs: {
                                        cols: "12",
                                        md: "6",
                                        order: "2",
                                        "order-md": "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "text-nowrap mr-50",
                                          attrs: {
                                            for: "invoice-data-sales-person",
                                          },
                                        },
                                        [_vm._v("Staff:")]
                                      ),
                                      _c("b-form-select", {
                                        attrs: {
                                          options: _vm.optionsSalesPerson,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.template.salesPersonId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.template,
                                              "salesPersonId",
                                              $$v
                                            )
                                          },
                                          expression: "template.salesPersonId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("hr", { staticClass: "invoice-spacing" }),
                          _c(
                            "h4",
                            {
                              staticClass:
                                "my-2 d-flex justify-content-start mx-3",
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.product.description)),
                              ]),
                            ]
                          ),
                          _c(
                            "b-card-body",
                            {
                              staticClass: "invoice-padding form-item-section",
                            },
                            [
                              _c(
                                "quill-editor",
                                {
                                  attrs: { options: _vm.editorOption },
                                  model: {
                                    value: _vm.template.text,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.template, "text", $$v)
                                    },
                                    expression: "template.text",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "toolbar", id: "toolbar" },
                                      slot: "toolbar",
                                    },
                                    [
                                      _c("button", { staticClass: "ql-bold" }, [
                                        _vm._v("Bold"),
                                      ]),
                                      _c(
                                        "button",
                                        { staticClass: "ql-italic" },
                                        [_vm._v("Italic")]
                                      ),
                                      _c(
                                        "button",
                                        { staticClass: "ql-underline" },
                                        [_vm._v("Underline")]
                                      ),
                                      _c(
                                        "button",
                                        { staticClass: "ql-strike" },
                                        [_vm._v("Strike")]
                                      ),
                                      _c(
                                        "button",
                                        { staticClass: "ql-blockquote" },
                                        [_vm._v("Quote")]
                                      ),
                                      _c("button", {
                                        staticClass: "ql-list",
                                        attrs: { value: "ordered" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-list",
                                        attrs: { value: "bullet" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-indent",
                                        attrs: { value: "-1" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-indent",
                                        attrs: { value: "+1" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-script",
                                        attrs: { value: "sub" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-script",
                                        attrs: { value: "super" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-background",
                                      }),
                                      _c("select", { staticClass: "ql-font" }, [
                                        _c("option", {
                                          attrs: { selected: "selected" },
                                        }),
                                        _c(
                                          "option",
                                          { attrs: { value: "serif" } },
                                          [_vm._v("serif")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "monospace" } },
                                          [_vm._v("monospace")]
                                        ),
                                      ]),
                                      _c(
                                        "select",
                                        { staticClass: "ql-header" },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "1" } },
                                            [_vm._v("Heading 1")]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "2" } },
                                            [_vm._v("Heading 2")]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "3" } },
                                            [_vm._v("Heading 3")]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "4" } },
                                            [_vm._v("Heading 4")]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "5" } },
                                            [_vm._v("Heading 5")]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "6" } },
                                            [_vm._v("Heading 6")]
                                          ),
                                          _c("option", {
                                            attrs: { selected: "" },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "select",
                                        { staticClass: "ql-align" },
                                        [
                                          _c("option", {
                                            attrs: { selected: "" },
                                          }),
                                          _c("option", {
                                            attrs: { value: "center" },
                                          }),
                                          _c("option", {
                                            attrs: { value: "right" },
                                          }),
                                          _c("option", {
                                            attrs: { value: "justify" },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-card-body",
                            {
                              staticClass: "invoice-padding form-item-section",
                              staticStyle: { "text-align": "left" },
                              attrs: { title: "Note for Service Request" },
                            },
                            [
                              _c(
                                "quill-editor",
                                {
                                  attrs: { options: _vm.editorOptionNote },
                                  model: {
                                    value: _vm.template.note,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.template, "note", $$v)
                                    },
                                    expression: "template.note",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: {
                                        slot: "toolbar",
                                        id: "toolbar-note",
                                      },
                                      slot: "toolbar",
                                    },
                                    [
                                      _c("button", { staticClass: "ql-bold" }, [
                                        _vm._v("Bold"),
                                      ]),
                                      _c(
                                        "button",
                                        { staticClass: "ql-italic" },
                                        [_vm._v("Italic")]
                                      ),
                                      _c(
                                        "button",
                                        { staticClass: "ql-underline" },
                                        [_vm._v("Underline")]
                                      ),
                                      _c(
                                        "button",
                                        { staticClass: "ql-strike" },
                                        [_vm._v("Strike")]
                                      ),
                                      _c(
                                        "button",
                                        { staticClass: "ql-blockquote" },
                                        [_vm._v("Quote")]
                                      ),
                                      _c("button", {
                                        staticClass: "ql-list",
                                        attrs: { value: "ordered" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-list",
                                        attrs: { value: "bullet" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-indent",
                                        attrs: { value: "-1" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-indent",
                                        attrs: { value: "+1" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-script",
                                        attrs: { value: "sub" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-script",
                                        attrs: { value: "super" },
                                      }),
                                      _c("button", {
                                        staticClass: "ql-background",
                                      }),
                                      _c("select", { staticClass: "ql-font" }, [
                                        _c("option", {
                                          attrs: { selected: "selected" },
                                        }),
                                        _c(
                                          "option",
                                          { attrs: { value: "serif" } },
                                          [_vm._v("serif")]
                                        ),
                                        _c(
                                          "option",
                                          { attrs: { value: "monospace" } },
                                          [_vm._v("monospace")]
                                        ),
                                      ]),
                                      _c(
                                        "select",
                                        { staticClass: "ql-header" },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "1" } },
                                            [_vm._v("Heading 1")]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "2" } },
                                            [_vm._v("Heading 2")]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "3" } },
                                            [_vm._v("Heading 3")]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "4" } },
                                            [_vm._v("Heading 4")]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "5" } },
                                            [_vm._v("Heading 5")]
                                          ),
                                          _c(
                                            "option",
                                            { attrs: { value: "6" } },
                                            [_vm._v("Heading 6")]
                                          ),
                                          _c("option", {
                                            attrs: { selected: "" },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "select",
                                        { staticClass: "ql-align" },
                                        [
                                          _c("option", {
                                            attrs: { selected: "" },
                                          }),
                                          _c("option", {
                                            attrs: { value: "center" },
                                          }),
                                          _c("option", {
                                            attrs: { value: "right" },
                                          }),
                                          _c("option", {
                                            attrs: { value: "justify" },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("hr", { staticClass: "invoice-spacing" }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }